import { render, staticRenderFns } from "./ehc-listing-import.vue?vue&type=template&id=c22f72c2"
import script from "./ehc-listing-import.vue?vue&type=script&lang=js"
export * from "./ehc-listing-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports